export const updateParent = (action, options, e) => {
  window.parent.postMessage(JSON.stringify({ action: action, options: options, type: 'modal' }), '*');
}

export const setHeight = height => updateParent('height', height);

export const emitEvent = (user, event) => updateParent('creditkey-event', { user: user ? user.email : null, event: event });
